import { useContext } from "react";
import { LeadDashboardContext } from "./LeadDashboard.context";

export function useLeadDashboardContext() {
    const context = useContext(LeadDashboardContext)

    if (!context) {
        throw new Error("useLeadDashboardContext deve ser utilizado apenas dentro de LeadDashboardProvider")
    }

    return context
}